import React from 'react';
import { Box, HStack, Text, Tooltip } from '@chakra-ui/react';
import { Icon } from '@app/components/Icon';

export const BoostBadge = () => {
  return (
    <Tooltip
      label={
        <Box
          sx={{
            padding: 4,
            backgroundColor: 'gray.1',
            borderRadius: 2,
            color: 'boost'
          }}
        >
          Boosted
        </Box>
      }
      portalProps={{ appendToParentPortal: true }}
      placement="top"
      zIndex={1000}
    >
      <HStack gap={2} alignItems="center">
        <Icon
          name="flame"
          style={{ color: 'var(--chakra-colors-boost)', width: '24px' }}
        />
        <Text
          fontSize="12px"
          // fontWeight={500}
          color="boost"
          sx={{
            border: '1px solid',
            borderColor: 'boost',
            borderRadius: '4px',
            padding: '2px 4px'
          }}
        >
          Boost
        </Text>
      </HStack>
    </Tooltip>
  );
};
